export default {
  pub: {
    pageHeader: {
      demo: 'Demo',
      userManagement: 'UserManagement'
    }
  }
}
